import {
    Dropdown,
    DropdownItem,
    DropdownItemGroup,
    Text,
} from "@amzn/storm-ui";
import { sortBy } from "lodash";
import React from "react";

import {
    accountOptions,
    globalAccountOptions,
    icmAccountOptions,
    nonEndemicAccountOptions,
} from "../../config/testSite/sfAccountOptions";
import { QueryParam } from "../../utils/permission.utils";
import { sfAccountToIdentifier } from "../../utils/testSite.utils";

export type SFAccount = {
    [QueryParam.SALESFORCE_ID]?: string;
    [QueryParam.SALESFORCE_NAME]?: string;
    [QueryParam.MARKETPLACE_ID]?: string;
};

interface AccountPickerProps {
    sfAccountIdentifier: string;
    setSfAccountIdentifier: (account: string) => void;
}

const AccountLabel: React.FunctionComponent<{ option: SFAccount }> = ({
    option,
}) => {
    return (
        <Text>
            {option[QueryParam.SALESFORCE_NAME]} {" | "}
            Marketplace: {option[QueryParam.MARKETPLACE_ID]}
        </Text>
    );
};

export const AccountPicker: React.FunctionComponent<AccountPickerProps> = ({
    sfAccountIdentifier,
    setSfAccountIdentifier,
}) => {
    const OverrideLabel = (dropdownItem, value) => {
        if (
            [
                ...accountOptions,
                ...nonEndemicAccountOptions,
                ...icmAccountOptions,
                ...globalAccountOptions,
            ]
                .map((opt) => sfAccountToIdentifier(opt))
                .includes(value)
        ) {
            return dropdownItem;
        }
        return "Choose other accounts";
    };

    const handleChange = (identifier: string) => {
        setSfAccountIdentifier(identifier);
    };

    return (
        <Dropdown
            onChange={handleChange}
            selectedValue={sfAccountIdentifier}
            label="Salesforce Account"
            onOverrideLabel={OverrideLabel}
            data-testid="sf-picker"
        >
            <DropdownItemGroup label="Global">
                {sortBy(
                    [...globalAccountOptions],
                    [QueryParam.SALESFORCE_NAME],
                ).map((option) => {
                    return (
                        <DropdownItem
                            key={sfAccountToIdentifier(option)}
                            value={sfAccountToIdentifier(option)}
                            data-testid={option[QueryParam.SALESFORCE_ID]}
                        >
                            <AccountLabel option={option} />
                        </DropdownItem>
                    );
                })}
            </DropdownItemGroup>
            <DropdownItemGroup label="Endemic">
                {sortBy([...accountOptions], [QueryParam.SALESFORCE_NAME]).map(
                    (option) => {
                        return (
                            <DropdownItem
                                key={sfAccountToIdentifier(option)}
                                value={sfAccountToIdentifier(option)}
                                data-testid={option[QueryParam.SALESFORCE_ID]}
                            >
                                <AccountLabel option={option} />
                            </DropdownItem>
                        );
                    },
                )}
            </DropdownItemGroup>
            <DropdownItemGroup label="Non - Endemic">
                {sortBy(
                    [...nonEndemicAccountOptions],
                    [QueryParam.SALESFORCE_NAME],
                ).map((option) => {
                    return (
                        <DropdownItem
                            key={sfAccountToIdentifier(option)}
                            value={sfAccountToIdentifier(option)}
                            data-testid={option[QueryParam.SALESFORCE_ID]}
                        >
                            <AccountLabel option={option} />
                        </DropdownItem>
                    );
                })}
            </DropdownItemGroup>
            <DropdownItemGroup label="ICM">
                {sortBy(
                    [...icmAccountOptions],
                    [QueryParam.SALESFORCE_NAME],
                ).map((option) => {
                    return (
                        <DropdownItem
                            key={sfAccountToIdentifier(option)}
                            value={sfAccountToIdentifier(option)}
                            data-testid={option[QueryParam.SALESFORCE_ID]}
                        >
                            <AccountLabel option={option} />
                        </DropdownItem>
                    );
                })}
            </DropdownItemGroup>
        </Dropdown>
    );
};
